export class Appeal {
    public recId: number | null = 0;
    public citationRecId: string | null = null;
    public amountOwed: number | null = null;
    public appealReason: string | null = null;
    public createdDateTime: Date | null = new Date();
    public customerComment: string | null = null;
    public hearingDecision: string | null = null;
    public appealDecision: string | null = null;
    public hearingOfficer: string | null = null;
    public hearingRequired: boolean | null = null;
    public requestForAppealDate: Date | null = new Date();
    public reviewDate: Date | null = new Date();
    public appellantNotifiedDate: Date | null = new Date();
    public reviewBy: string | null = null;
    public userId: string | null = null;
    public appealComments: string | null = null;
    public reviewerComment: string | null = null;
}
